<template>
  <div>
    <PageTitle title="Edit Room" :backBtn="true" :showLoading="isLoading" />
    <v-container fluid class="lighten-12">
      <ValidationObserver ref="observer">
        <!-- Page Title -->
        <!-- <PageTitle title="Create Product" :backBtn="true" /> -->
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>General</v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{errors}"
                          name="Room name"
                          rules="required|no_spaces_only"
                          vid="name"
                        >
                          <v-text-field
                            outlined
                            v-model="Room.name"
                            :error-messages="errors"
                            dense
                            hide-details="auto"
                            label="Room Name"
                            @blur="Room.name = Room.name.trim()"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{errors}"
                          name="Floor"
                          dense
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="Room.floor_id"
                            item-text="name"
                            item-value="id"
                            :items="roomFloors"
                            :error-messages="errors"
                            :loading="loadingBrand"
                            :search-input.sync="searchBrand"
                            outlined
                            dense
                            hide-details="auto"
                            label="Floor"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{errors}"
                          :rules="{regex: /^[+,-,0-9]*[+,-,0-9]*$/}"
                        >
                          <v-text-field
                            outlined
                            v-model="Room.phone_expression"
                            dense
                            :error-messages="errors"
                            hide-details="auto"
                            maxlength="13"
                            label="PhoneNumber"
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <v-checkbox
                          v-model="nonSmoking"
                          label="Non-Smoking"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <!-- <v-row>
                      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="Room Type"
                          dense
                          rules="required"
                        >
                          <v-autocomplete
                            v-model="Room.room_type_id"
                            item-text="name"
                            item-value="id"
                            :items="roomTypes"
                            outlined
                            required
                            dense
                            hide-details="auto"
                            label="Room Type"
                          ></v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                     
                    </v-row> -->
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>Room Type Details</v-card-title>

                  <v-container>
                    <v-data-table
                      v-if="isLoadingAmount"
                      :headers="columns"
                      :items="roomTypesToEdit"
                      hide-default-footer
                      v-model="selectedroomtypes"
                      disable-pagination
                      show-select
                      fixed-header
                      class="elevation-1"
                    >
                      <template v-slot:item.name="{item}">
                        <v-autocomplete
                          v-model="item.id"
                          item-text="name"
                          item-value="id"
                          :items="roomTypes"
                          :error-messages="errors"
                          outlined
                          required
                          dense
                          disabled
                          hide-details="auto"
                          label="Room Type"
                        ></v-autocomplete>
                      </template>

                      <template v-slot:item.amount="{item}">
                        <v-text-field
                          outlined
                          @input="RoomTypeAmountChange(item)"
                          v-model="item.amount_of_roomtype"
                          :error-messages="item.RoomTypeAmountError"
                          dense
                          type="number"
                          hide-details="auto"
                          label="amount"
                          :min="0"
                        ></v-text-field>
                      </template>
                    </v-data-table>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>Note</v-card-title>

                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-textarea
                          rows="3"
                          outlined
                          v-model="Room.remarks"
                          hide-details
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                  <v-container>
                    <v-row>
                      <v-col cols="12" class="pb-0">
                        <v-flex class="pt-0 pa-1">
                          <FileUpload
                            ref="fileUpload"
                            title="Image"
                            :multiple="true"
                            @ReturnItemName="DeleteImages"
                            @isImageUpdated="onChangeImageUpload"
                            v-model="selectedImages"
                            :externalFiles="Room.images || []"
                            size="10000"
                            :types="['jpeg', 'png', 'jpg']"
                            :showPreview="true"
                            accept="image/x-png,image/gif,image/jpeg"
                          />
                        </v-flex>
                      </v-col>

                      <v-col cols="12">
                        <v-row>
                          <v-col
                            v-for="(img, index) in selectedImages"
                            :key="index"
                            cols="6"
                            md="4"
                            lg="3"
                          >
                            <v-card class="pa-2" outlined>
                              <v-img
                                :src="getImageUrl(img)"
                                height="120"
                                cover
                              ></v-img>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-col cols="12" class="text-right pa-0">
          <v-btn
            depressed
            small
            class="ml-1 text-white btn_medium"
            @click="clear"
            >Clear</v-btn
          >
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Submit</v-btn
          >
        </v-col>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
// import RoomProperty from "./RoomProperty.vue";
import {required, email, max, regex} from 'vee-validate/dist/rules';
import FileUpload from '@/components/base/FileUpload';
import {Room} from '../../../models/Room';

import {ProductEntity} from '../../../models/EntityModels/ProductEntity';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import {ProductBrand} from '../../../models/ProductBrand';
// import the component
import Treeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import axios from '@/plugins/axios';
setInteractionMode('eager');

// Mixins
// import Categories from "@/mixins/Categories";

extend('required', {
  ...required,
  message: '{_field_} is required',
});

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters',
});

extend('no_spaces_only', {
  validate: value => {
    return value && value.trim().length > 0;
  },
  message: '{_field_} cannot be empty or spaces only',
});

extend('email', {
  ...email,
  message: 'Email must be valid',
});
extend('regex', {
  ...regex,
  message: 'This entry can only contain numbers.',
});
export default {
  // mixins: [Categories],
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    FileUpload,
    // RoomProperty,
  },
  computed: {
    // UI label is "Non-Smoking" but API field is `is_smoking` (true means smoking allowed)
    nonSmoking: {
      get() {
        return !this.Room.is_smoking;
      },
      set(val) {
        this.Room.is_smoking = !val;
      },
    },
  },
  data: () => ({
    roomFloors: [],
    RoomDetails: new Room(),
    roomTypes: [],
    isLoadingAmount: true,

    selectedImages: [],
    imageUpdated: null,
    roomTypesToEdit: [],
    RoomTypeAmountError: [],
    selectedroomtypes: [],
    //bedTypes:[],
    Room: new Room(),
    columns: [
      {
        text: 'Room Types',
        value: 'name',
        show: true,
        disabled: true,
      },
      {
        text: 'Amounts',
        value: 'amount',
        align: 'left',
        show: true,
        disabled: true,
      },
    ],
    errors: [],
    messages: [],
    suppliers: [],
    selectedSuppliers: [],
  }),
  created() {
    this.GetFloors();
    this.GetRoomTypes();
    // this.GetBedTypes();
    // this.GetSingleRoomImages();
  },
  methods: {
    RoomTypeAmountChange(item) {
      this.isLoadingAmount = false;
      item.amount_of_roomtype = item.amount_of_roomtype;
      // setTimeout(() => {
      this.isLoadingAmount = true;
      // }, 50);
    },
    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },
    DeleteImages(value) {
      let id = this.$route.params.id;

      var filename = value.substring(value.lastIndexOf('/') + 1);

      axios
        .delete(`hms/rooms/${id}/images/${filename}`)
        .then(res => {})
        .catch(err => {});
    },
    async submit() {
      this.clickSubmit = true;
      const isValid = await this.$refs.observer.validate();
      let error = false;
      let self = this;

      self.selectedroomtypes.map(p => {
        if (p.amount_of_roomtype <= 0) {
          this.isLoadingAmount = false;
          p.RoomTypeAmountError = 'Amount should be greater than 0';
          setTimeout(() => {
            this.isLoadingAmount = true;
          }, 50);
          error = true;
        }
      });
      if (isValid && !error) {
        this.EditRoom();
      }
    },

    clear() {
      this.Room = new Room();
      this.selectedImages = [];
      this.selectedroomtypes = [];
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.removeAllItems();
      }
      this.$refs.observer.reset();
    },
    EditRoom() {
      this.isLoading = true;
      this.Room.types = [];
      this.selectedroomtypes.map(p => {
        this.Room.types.push({
          room_type_id: p.id,
          amount: p.amount_of_roomtype,
        });
      });
      let id = this.$route.params.id;
      axios
        .patch(`hms/rooms/${id}`, this.Room.toRequestModel())
        .then(async res => {
          this.succeeed = true;
          if (this.selectedImages) {
            await this.UploadRoomImage(this.$route.params.id);
          }
          this.$toast.success('Room updated successfully');
          this.$router.push('/room');
        })
        .catch(err => {
          this.$refs.observer.setErrors(err.response.data.error);

          // this.messages.push(err.data.title);
          this.$toast.error('Room Update failed');
          this.isDisabledSubmit = false;
          this.isLoading = false;
        });
    },
    async UploadRoomImage(productId) {
      let fromData = new FormData();

      if (this.selectedImages && this.imageUpdated) {
        for (var i = 0; i < this.selectedImages.length; i++) {
          fromData.append('images', this.selectedImages[i]);
        }
        // fromData.append("id", productId);
        // console.log("SELECTED IMAGES", fromData);

        axios
          .post(`hms/rooms/${productId}/image-upload`, fromData)
          .then(res => {})
          .catch(err => {
            this.$toast.error('Room image uploading failed');
          });
      }
    },
    GetFloors() {
      axios
        .get(`hms/floors`)
        .then(res => {
          this.roomFloors = res.data.data;
        })
        .catch(err => {});
    },
    GetRoomTypes() {
      axios
        .get(`hms/room-types`)
        .then(res => {
          this.roomTypes = res.data.data;
          this.roomTypes.map(p => {
            return (p.amount_of_roomtype = 0), (p.RoomTypeAmountError = '');
          });
          this.GetRoom();
        })
        .catch(err => {});
    },
    //     GetBedTypes() {
    //   axios
    //     .get(`hms/bed-types`)
    //     .then((res) => {

    //       this.bedTypes = res.data.data;
    // this.GetRoom();

    //     })
    //     .catch((err) => {});
    // },
    async GetRoom() {
      let id = this.$route.params.id;
      axios
        .get(`hms/rooms/${id}`)
        .then(res => {
          this.Room = Room.toViewModel(res.data);
          this.roomTypes.map(r => {
            let rootype = this.Room.selectedroomtypes.find(p => p.id == r.id);
            if (rootype) {
              this.roomTypesToEdit.push(rootype);
            } else {
              this.roomTypesToEdit.push(r);
            }
          });
          this.selectedroomtypes = this.Room.selectedroomtypes;
        })
        .catch(err => {});
    },
  },

  watch: {
    searchBrand: {
      handler(val) {
        this.GetBrandByQuery(val);
      },
      deep: true,
    },
    searchCategory: {
      handler(val) {
        this.GetProductCategoriesByQuery(val);
      },
      deep: true,
    },
  },
};
</script>
